import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import ExcelJS from 'exceljs';

const Calculators = () => {
        function ConvertAPIGravity(){
            const [APIGravity, setAPIGravity] = useState<number>(0);
            const [convertedValue, setConvertedValue] = useState<number|null>(null);
            const [copiedCell, setCopiedCell] = useState<string | null>(null);
            function handleCopy(value: string, cellId: string) {
                navigator.clipboard.writeText(value);
                setCopiedCell(cellId);
                setTimeout(() => setCopiedCell(null), 1200); // Hide after 1.2s
            }
            function handleChange(value:number, ){
                setAPIGravity(value);
                const gravity = value;
                if (!isNaN(gravity) && gravity >0) {
                    const converted = Number((141.5/(gravity + 131.5) ));
                    console.log(gravity)
                    console.log(converted);
                    setConvertedValue(converted);
                }else{
                    setConvertedValue(null);
                }
            }

            return(
                <>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input 
                            id="gravity" 
                            type="number" 
                            step="0.1" 
                            placeholder="Enter API Gravity" 
                            onChange={e => handleChange(Number(e.target.value))}
                            onClick={e => (e.target as HTMLInputElement).select()}
                        />
                    </form>
                    {convertedValue && (
                        <table className="conversion-table">
                            <thead>
                                <tr>
                                    <th>Unit</th>
                                    <th>Value</th>
                                    <th>Formula (60F values)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        SG
                                    </td>
                                    <td
                                        onClick={() => handleCopy((convertedValue).toFixed(3), 'val-SG')}
                                        className="copy-cell"
                                    >
                                        {(convertedValue).toFixed(3)}
                                        {copiedCell === 'val-SG' && <span className="copy-tooltip">Copied!</span>}
                                    </td>
                                    <td>
                                        SG × 1
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        kg/m³
                                    </td>
                                    <td
                                        onClick={() => handleCopy((convertedValue * 998.98).toFixed(2), 'val-kg')}
                                        className="copy-cell"
                                    >
                                        {(convertedValue * 998.98).toFixed(1)}
                                        {copiedCell === 'val-kg' && <span className="copy-tooltip">Copied!</span>}
                                    </td>
                                    <td>
                                        SG × 998.98
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        lbm/gal
                                    </td>
                                    <td
                                        onClick={() => handleCopy((convertedValue * 8.337).toFixed(2), 'val-gal')}
                                        className="copy-cell"
                                    >
                                        {(convertedValue * 8.337).toFixed(2)}
                                        {copiedCell === 'val-gal' && <span className="copy-tooltip">Copied!</span>}
                                    </td>
                                    <td>
                                        SG × 8.337
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        lbm/bbl
                                    </td>
                                    <td
                                        onClick={() => handleCopy((convertedValue * 350.150).toFixed(2), 'val-bbl')}
                                        className="copy-cell"
                                    >
                                        {(convertedValue * 350.150).toFixed(2)}
                                        {copiedCell === 'val-bbl' && <span className="copy-tooltip">Copied!</span>}
                                    </td>
                                    <td>
                                        SG × 350.150
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    )}
                </>
            );
        }
        function ConvertSGGravity(){
            const [APIGravity, setAPIGravity] = useState<number>(0);
            const [convertedValue, setConvertedValue] = useState<number|null>(null);
            const [copiedCell, setCopiedCell] = useState<string | null>(null);
            function handleCopy(value: string, cellId: string) {
                navigator.clipboard.writeText(value);
                setCopiedCell(cellId);
                setTimeout(() => setCopiedCell(null), 1200); // Hide after 1.2s
            }
            function handleChange(value:number, ){
                setAPIGravity(value);
                const gravity = value;
                if (!isNaN(gravity) && gravity >0) {
                    const converted = Number(((141.5/gravity) - 131.5 ));
                    setConvertedValue(converted);
                }else{
                    setConvertedValue(null);
                }
            }

            return(
                <>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <input 
                            id="gravity" 
                            type="number" 
                            step="0.001" 
                            placeholder="Enter SG Gravity" 
                            onChange={e => handleChange(Number(e.target.value))}
                            onClick={e => (e.target as HTMLInputElement).select()}
                        />
                    </form>
                    {convertedValue && (
                        <table className="conversion-table">
                            <thead>
                                <tr>
                                    <th>API Gravity</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    
                                    <td
                                        onClick={() => handleCopy((convertedValue).toFixed(3), 'val-API')}
                                        className="copy-cell"
                                    >
                                        {(convertedValue).toFixed(3)}
                                        {copiedCell === 'val-API' && <span className="copy-tooltip">Copied!</span>}
                                    </td>
                                    
                                </tr>
                                
                            </tbody>
                        </table>
                    )}
                </>
            );
        }
        function ConvertGross_Net(){
            const [form, setForm] = useState({
                old_gravity: null,
                corrected_gravity: null,
                gross_barrels: null,
                bsw: null
            });
            const [convertedMass, setConvertedMass] = useState<number|null>(null);
            const [convertedValue, setConvertedValue] = useState<number|null>(null);
            const [copiedCell, setCopiedCell] = useState<string | null>(null);
            function handleCopy(value: string, cellId: string) {
                navigator.clipboard.writeText(value);
                setCopiedCell(cellId);
                setTimeout(() => setCopiedCell(null), 1200); // Hide after 1.2s
            }
            const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                const { name, value } = e.target;
                setForm(prev => ({ ...prev, [name]: value }));
            };
            function submitForm(e:React.FormEvent, ){
                e.preventDefault()
                console.log(form);
                const old_gravity = Number(form["old_gravity"]);
                const corrected_gravity = Number(form["corrected_gravity"]);
                const gross_barrels = Number(form["gross_barrels"]);
                const bsw = Number(form["bsw"]);
                if (bsw>0 && gross_barrels >0) {
                    const old_converted = Number((141.5/(old_gravity + 131.5) ));
                    const corrected_converted = Number((141.5/(corrected_gravity + 131.5) ));
                    const bsw_factor = 1 - (bsw / 100);
                    const converted = old_converted * (gross_barrels * bsw_factor);
                    setConvertedMass(converted*8.33);
                    const netVolume = converted/corrected_converted;
                    setConvertedValue(netVolume);
                }else{
                    setConvertedMass(null);
                    setConvertedValue(null);
                }
            }

            return(
                <>
                    <form onSubmit={(e) => submitForm(e)}>
                        <input 
                            id="old_gravity" 
                            name="old_gravity"
                            type="number" 
                            step="0.1" 
                            placeholder="Enter Observed Gravity" 
                            value={form?.old_gravity||''}
                            onClick={e => (e.target as HTMLInputElement).select()}
                            onChange={handleChange}
                        />
                        <input 
                            id="corrected_gravity" 
                            name="corrected_gravity"
                            type="number" 
                            step="0.1" 
                            placeholder="Enter STP Gravity" 
                            value={form?.corrected_gravity||''}
                            onClick={e => (e.target as HTMLInputElement).select()}
                            onChange={handleChange}
                        />
                        <input 
                            id="gross_barrels" 
                            name="gross_barrels"
                            type="number" 
                            step="0.1" 
                            placeholder="Enter Gross Barrels" 
                            value={form?.gross_barrels||''}
                            onClick={e => (e.target as HTMLInputElement).select()}
                            onChange={handleChange}
                        />
                        <input 
                            id="bsw" 
                            name="bsw"
                            type="number" 
                            step="0.1" 
                            placeholder="Enter BS&W" 
                            value= {form?.bsw || ''}
                            onChange={handleChange}
                            onClick={e => (e.target as HTMLInputElement).select()}
                        />
                        <button type="submit">Convert </button>
                        {convertedValue?(
                            <button onClick={()=> setForm({
                                old_gravity: null,
                                corrected_gravity: null,
                                gross_barrels: null,
                                bsw: null
                            })}>
                                Clear
                            </button>
                        ):(<></>)}
                    </form>
                    {convertedValue && (
                        <table className="conversion-table">
                            <thead>
                                <tr>
                                    <th>Total Mass (lb)</th>
                                    <th>Corrected Volume</th>
                                    
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td
                                        onClick={() => handleCopy((convertedMass ? convertedMass : 0).toFixed(2), 'val-lb')}
                                        className="copy-cell"
                                    >
                                        {(convertedMass ? convertedMass : 0).toFixed(2)}

                                        {copiedCell === 'val-lb' && <span className="copy-tooltip">Copied!</span>}

                                    </td>  
                                    <td
                                        onClick={() => handleCopy((convertedValue).toFixed(2), 'val-bbl')}
                                        className="copy-cell"
                                    >
                                        {(convertedValue).toFixed(2)}

                                        {copiedCell === 'val-bbl' && <span className="copy-tooltip">Copied!</span>}

                                    </td>                                    
                                </tr>
                                
                            </tbody>
                        </table>
                    )}
                </>
            );
        }

        function WeightedAverage(){
            interface measurement {
                bsw: number | null;
                barrelMark: number | null;
            }
            const [measurementCount, setMeasurementCount] = useState<number>(1);
            const [totalBarrels, setTotalBarrels] = useState<number | null>(null);
            const [form, setForm] = useState<measurement[]>([]);
            const [convertedMass, setConvertedMass] = useState<number|null>(null);
            const [convertedValue, setConvertedValue] = useState<number|null>(null);
            const [copiedCell, setCopiedCell] = useState<string | null>(null);
            function handleCopy(value: string, cellId: string) {
                navigator.clipboard.writeText(value);
                setCopiedCell(cellId);
                setTimeout(() => setCopiedCell(null), 1200); // Hide after 1.2s
            }
            const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, index:number) => {
                const { name, value } = e.target;
                setForm(prev => {
                    const updatedForm = [...prev];
                    updatedForm[index] = { ...updatedForm[index], [name]: value };
                    return updatedForm;
                });
                if(form.length > 0){
                    const last = form[form.length - 1];
                    console.log(form.length)
                    if(last.barrelMark !== null && last.bsw !== null){
                        setMeasurementCount(form.length + 1);
                    }
                }
            };
            function submitForm(e:React.FormEvent, ){
                e.preventDefault()
                let sum = 0;
                if (form.length > 0 && totalBarrels !== null) {
                    // First interval: 0 to first barrelMark
                    if (form[0].barrelMark !== null && form[0].bsw !== null) {
                        sum += (form[0].barrelMark - 0) * Number(form[0].bsw);
                    }
                    
                    // Middle intervals
                    for (let i = 1; i < form.length; i++) {
                        if (
                            form[i].barrelMark !== null && form[i].bsw !== null &&
                            form[i - 1].barrelMark !== null
                        ) {
                            var bsw1 = Number(form[i].bsw);
                            var bsw2 = Number(form[i - 1].bsw);
                            var barrel1 = Number(form[i].barrelMark);
                            var barrel2 = Number(form[i - 1].barrelMark);
                            sum += ((barrel1 - barrel2)) * ((bsw1 + bsw2) / 2);
                        }
                        
                    }
                    // Last interval: last barrelMark to totalBarrels
                    const last = form[form.length - 1];
                    if (last.barrelMark !== null && last.bsw !== null) {
                        sum += (totalBarrels - last.barrelMark) * Number(last.bsw);
                    }
                    
                    // Weighted average
                    const weightedAverage = Number((sum / totalBarrels).toFixed(1));
                    setConvertedValue(weightedAverage);
                }
                
                
            }

            return(
                <>
                    <form onSubmit={(e) => submitForm(e)}>
                        <input 
                            id="total_barrels" 
                            name="total_barrels"
                            type="number" 
                            step="0.1" 
                            placeholder="Enter Total Barrels" 
                            value={totalBarrels||''}
                            onClick={e => (e.target as HTMLInputElement).select()}
                            onChange={e => setTotalBarrels(parseFloat(e.target.value))}
                        />
                        {Array.from({ length: measurementCount }).map((_, index) => (
                            <div key={index}>
                                <input
                                    name="bsw"
                                    type="number"
                                    step="0.1"
                                    value={form[index]?.bsw || ''}
                                    placeholder={`Enter BSW Measurement ${index + 1}`}
                                    onChange={e => handleChange(e, index)}
                                />
                                <input
                                    name="barrelMark"
                                    type="number"
                                    step="0.1"
                                    value={form[index]?.barrelMark || ''}
                                    placeholder={`Enter Barrel Mark ${index + 1}`}
                                    onChange={e => handleChange(e, index)}
                                />
                            </div>
                        ))}
                        <button type="submit">Convert </button>
                        <br/>
                        {
                            form?.length > 0 ? (
                                <button onClick={() => {
                                    setForm([]);
                                    setTotalBarrels(null);
                                    setConvertedValue(null);
                                    setMeasurementCount(1);
                                }}> Clear </button>
                            ) : null
                        }
                        
                        

                    </form>
                    {convertedValue !== null && (
                        <div>
                            <h3>Weighted Average:</h3>
                            <p>{convertedValue}%</p>
                        </div>
                    )}

                </>
            );
        }
        function API_11_Correction(){
            const [form, setForm] = useState<any>();
            const [correctedGravity, setCorrectedGravity] = useState<number >(0);
            const [netBarrels, setNetBarrels] = useState<number>(0);
            const [copiedCell, setCopiedCell] = useState<string | null>(null);
            function handleCopy(value: string, cellId: string) {
                navigator.clipboard.writeText(value);
                setCopiedCell(cellId);
                setTimeout(() => setCopiedCell(null), 1200); // Hide after 1.2s
            }
            const requiredHeaders = [
                { key: 'observedGravity', label: 'Observed Gravity' },
                { key: 'observedTemperature', label: 'Observed Temperature' },
                { key: 'grossBarrels', label: 'Gross Barrels' },
                { key: 'bsw', label: 'BS&W' },
                { key: 'topTemperature', label: 'Top Temperature' },
                { key: 'bottomTemperature', label: 'Bottom Temperature' }
            ];

            const [excelRows, setExcelRows] = useState<any[]>([]);
            const [headerMap, setHeaderMap] = useState<{[key: string]: string}>({});
            const [showHeaderMatch, setShowHeaderMatch] = useState(false);
            interface measurement{
                bsw: number|undefined;
                observedGravity: number|undefined;
                observedTemperature: number|undefined;
                topTemperature: number|undefined;
                bottomTemperature: number|undefined;
                grossBarrels: number|undefined;
            }
            const initialFormState = {
                bsw: '',
                observedGravity: '',
                observedTemperature: '',
                topTemperature: '',
                bottomTemperature: '',
                grossBarrels: ''
            };

            function clearForm(){
                console.log("Clearing form");
                setForm(initialFormState);
                setCorrectedGravity(0);
                setNetBarrels(0);
            }
            
            function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
                const { name, value } = e.target;
                
                    setForm({ ...form, [name]: parseFloat(value) }); 
                
            }

            function handleExcelUpload(e: React.ChangeEvent<HTMLInputElement>) {
                const file = e.target.files?.[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onload = (evt) => {
                    const data = evt.target?.result;
                    // Use XLSX.read with type: 'array'
                    const workbook = XLSX.read(data, { type: 'array' });
                    const sheetName = workbook.SheetNames[0];
                    const worksheet = workbook.Sheets[sheetName];
                    const json = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                    setExcelRows(json);

                    // ...regex header matching logic...
                    const excelHeaders = Object.keys(json[0] || {});
                    const regexMap: { [key: string]: RegExp[] } = {
                        observedGravity: [/gravity/i, /api/i],
                        observedTemperature: [/(?=.*temp)(?!.*bot)(?!.*top)/i, /obs.*temp/i],
                        grossBarrels: [/gross.*barrel/i, /gross.*bbl/i, /gross/i],
                        bsw: [/bsw/i, /water/i, /basic.*sediment.*water/i],
                        topTemperature: [/top.*temp/i, /top.*temperature/i, /^(?=.*top)(?=.*temp).*$/i],
                        bottomTemperature: [/bottom.*temp/i, /bottom.*temperature/i, /^(?=.*bottom)(?=.*temp).*$/i],
                    };
                    const newHeaderMap: { [key: string]: string } = {};
                    requiredHeaders.forEach(({ key }) => {
                        let match = '';
                        for (const header of excelHeaders) {
                            if (regexMap[key]?.some((re) => re.test(header))) {
                                match = header;
                                break;
                            }
                        }
                        newHeaderMap[key] = match; // blank if no match
                    });
                    setHeaderMap(newHeaderMap);
                    setShowHeaderMatch(true);
                };
                reader.readAsArrayBuffer(file); // Use ArrayBuffer instead of BinaryString
            }

            // Handle header mapping change
            function handleHeaderMapChange(key: string, value: string) {
                setHeaderMap(prev => ({ ...prev, [key]: value }));
            }

            // Batch process and export
            async function handleBatchProcessAndExport() {
                // Validate header mapping
                if (!Object.values(headerMap).every(v => v)) {
                    alert('Please match all required headers.');
                    return;
                }
                // Prepare output rows
                const outputRows = [];
                for (const row of excelRows) {
                    // Map Excel columns to required inputs
                    const input = Object.fromEntries(
                        requiredHeaders.map(h => [h.key, parseFloat(row[headerMap[h.key]])])
                    );
                    // Compute correctedGravity and netBarrels
                    const density = (141.5/(input.observedGravity + 131.5)*999.016 );
                    let stp_guess = input.observedTemperature < 60 ? density + 10 : density - 10;
                    let temp_output = estimateAPI(density, input.observedTemperature, 0);
                    let count = 0;
                    while(Math.abs(temp_output-density) >0.001){
                        const f = estimateAPI(stp_guess, input.observedTemperature, 0) - density;
                        if (Math.abs(f) < 0.001 || count > 100) {
                            temp_output = estimateAPI(stp_guess, input.observedTemperature, 0);
                            break;
                        }
                        const h = 1e-6;
                        const f_prime =
                            (estimateAPI(stp_guess + h, input.observedTemperature, 0) -
                            estimateAPI(stp_guess - h, input.observedTemperature, 0)) /
                            (2 * h);
                        if (Math.abs(f_prime) < 1e-12) break;
                        stp_guess = stp_guess - f / f_prime;
                        count++;
                    }
                    const correctedGravity = (141.5/(stp_guess/999.016)-131.5 );
                    const tank_density = estimateAPI(stp_guess, (input.topTemperature+input.bottomTemperature)/2, 0);
                    const offloaded_oil_mass = input.grossBarrels * tank_density * (1-input.bsw/100);
                    const netBarrels = offloaded_oil_mass / stp_guess;

                    outputRows.push({
                        ...row,
                        Corrected_Gravity: correctedGravity.toFixed(2),
                        Net_Standard_Volume: netBarrels.toFixed(2)
                    });
                }
                // Export to Excel
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Results');
                worksheet.columns = [
                    ...Object.keys(outputRows[0]).map(key => ({ header: key, key })),
                ];
                outputRows.forEach(r => {
                    // Clean each row: replace undefined/null with empty string
                    Object.keys(r).forEach(key => {
                        if (r[key] === undefined || r[key] === null) {
                            r[key] = '';
                        } else if (typeof r[key] === 'object') {
                            r[key] = JSON.stringify(r[key]);
                        }
                    });
                    worksheet.addRow(r);
                });
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/octet-stream' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'corrected_results.xlsx';
                a.click();
                window.URL.revokeObjectURL(url);
                setShowHeaderMatch(false);
                setExcelRows([]);
                setHeaderMap({});
            }
            function convertGravity(gravity:number):number{ 
                    return (141.5/(gravity + 131.5)*999.016 );
            }
            function convertDensity(density:number):number{
                return (141.5/(density/999.016)-131.5 );
            }
            function correctedTemp(temperature:number):number{
                var celcius = (temperature - 32)/1.8;
                var tau = celcius/630;
                var delta = (
                    -0.148759 +
                        (-0.267408 +
                            (1.080760+
                                (1.269056+
                                    (-4.089591+
                                        (-1.871251+
                                            (7.438081 +
                                                -3.536296 * tau
                                            )*tau
                                        )*tau
                                    )*tau
                                )*tau
                            )*tau

                        )*tau
                )*tau;
                celcius = celcius - delta;
                return (1.8*celcius + 32);
            }
            function estimateAPI(density:number, alt_temp:number, alt_pres:number, thermal_expansion?:number):number{
                if(!alt_pres){
                    alt_pres = 0;
                }
                var alternate_temperature_IPTS68_shifted;
                var base_density_IPTS68_shifted;
                var delta_temp;
                var thermal_expansion_correction;
                var k0;
                var k1;
                var k2;
                var a;
                var b;
                var d60 = 0.01374979547;
                //console.log(density, alt_temp, alt_pres, thermal_expansion);
                if(alt_temp<-58 || alt_temp>302 || alt_pres < 0 || alt_pres >1500 || density < 610.6 || density >1163.5){
                    return 0;
                }
                alternate_temperature_IPTS68_shifted = correctedTemp(alt_temp);
                
                //Assume Crude Oil Commodity Group
                k0 = 341.0957;
                k1=0;
                k2 = 0;
                a = (d60/2)*(((k0/density)+k1)*(1/density)+k2);
                b = (2*k0+k1*density)/(k0+((k1+k2*density)*density));
                base_density_IPTS68_shifted = density*(1+((Math.exp(a*(1+0.8*a))-1)/(1+a*(1+1/6*a)*b)));
                thermal_expansion_correction = ((k0/base_density_IPTS68_shifted)+k1)*(1/base_density_IPTS68_shifted)+k2;
                delta_temp = alternate_temperature_IPTS68_shifted - 60.0068749;
                var ctl;
                var fs;
                var cpl;
                ctl = Math.exp(-thermal_expansion_correction*delta_temp*(1+0.8*thermal_expansion_correction*(delta_temp+d60)));
                fs = Math.exp(-1.9947+0.00013427*alternate_temperature_IPTS68_shifted+(793920+2326.0*alternate_temperature_IPTS68_shifted)/(base_density_IPTS68_shifted*base_density_IPTS68_shifted));
                cpl = 1/(1-(Math.pow(10, -5))*fs*alt_pres);
                var cptl = ctl*cpl;
                // console.log("Thermal Expansion Correction: "+thermal_expansion_correction);
                // console.log("CTL: "+ctl);
                // console.log("CPL: "+cpl);
                // console.log("CPTL: "+cptl);
                return density*cptl;
                
            }
            function calculateCorrectedGravity(e: React.FormEvent<HTMLFormElement>){
                console.log(form);
                e.preventDefault();
                
                if(form){
                    // Expect the following from the form: 
                    // bsw: number;
                    // observedGravity: number;
                    // observedTemperature: number;
                    // topTemperature: number;
                    // bottomTemperature: number;
                    // grossBarrels: number;
                    const density = convertGravity(form.observedGravity);
                    // Set an initial guess away from the observed density to be able to iteratively converge.
                    var stp_guess = 0;
                    if(form.observedTemperature<60){
                        stp_guess = density + 10;
                    }else{
                        stp_guess = density - 10
                    }
                    var temp_output = estimateAPI(density, form.observedTemperature, 0);
                    var count = 0;
                    //Iterate using Newton-Raphson method to find the solution of the standard density that would give the observed density at the observed temperature.
                    while(Math.abs(temp_output-density) >0.001){
                        const f = estimateAPI(stp_guess, form.observedTemperature, 0) - density;
                        if (Math.abs(f) < 0.001 || count > 100) {
                            temp_output = estimateAPI(stp_guess, form.observedTemperature, 0);
                            break;
                        }
                        // Numerical derivative
                        const h = 1e-6;
                        const f_prime =
                        (estimateAPI(stp_guess + h, form.observedTemperature, 0) -
                            estimateAPI(stp_guess - h, form.observedTemperature, 0)) /
                        (2 * h);
                        if (Math.abs(f_prime) < 1e-12) break; // avoid division by zero
                        stp_guess = stp_guess - f / f_prime;
                        count++;
                    }
                    setCorrectedGravity(convertDensity(stp_guess));
                    // Now, need to calculate the approximate density of the tank, as the observed gravity is at the observed temperature, but the tank has a top and bottom temperature.
                    // Use the average of the top and bottom temperature to estimate the tank density.
                    const tank_density = estimateAPI(stp_guess, (form.topTemperature+form.bottomTemperature)/2, 0);
                    console.log("Tank Density: "+tank_density);
                    // Mass is conserved, so taking the measured gross volume, and multiplying by the tank density and (1-bsw) to get the mass of oil. 
                    // Water is mostly incompressible, so we don't need to correct for temperature.
                    const offloaded_oil_mass = form.grossBarrels * tank_density * (1-form.bsw/100);
                    console.log("Offloaded Oil Mass (off unit): "+offloaded_oil_mass);
                    // Then, take the mass of oil and divide by the stp_guess density to get the net volume at standard conditions.
                    // This is an approximation, as the actual density of the oil in the tank will vary with temperature, but this should be close enough for most purposes.
                    // Finally, we can calculate the net barrels.
                    const standard_oil_volume = offloaded_oil_mass / stp_guess;
                    setNetBarrels(standard_oil_volume);
                }
            }
            return(
                <div>
                    
                    <form onSubmit={(e) => calculateCorrectedGravity(e)}>
                        <table>
                            <thead>
                                <tr>
                                <th>Observed Gravity</th>
                                <th>Observed Temperature</th>
                                <th>Gross Barrels</th>
                                <th>BS&W</th>
                                <th>Top Temperature</th>
                                <th>Bottom Temperature</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                <td>
                                    <input 
                                    id="observedGravity" 
                                    name="observedGravity"
                                    type="number" 
                                    step="0.001" 
                                    max="100"
                                    min="-10"
                                    placeholder="Enter Observed Gravity" 
                                    value={form?.observedGravity ?? ''}
                                    onClick={e => (e.target as HTMLInputElement).select()}
                                    onChange={handleChange}
                                    />
                                </td>
                                <td>
                                    <input 
                                    id="observedTemperature" 
                                    name="observedTemperature"
                                    type="number" 
                                    step="0.01" 
                                    min="-58"
                                    max="302"
                                    placeholder="Observed Temp" 
                                    value={form?.observedTemperature ?? ''}
                                    onClick={e => (e.target as HTMLInputElement).select()}
                                    onChange={handleChange}
                                    />
                                </td>
                                <td>
                                    <input 
                                    id="grossBarrels" 
                                    name="grossBarrels"
                                    type="number" 
                                    step="0.01" 
                                    placeholder="Enter Gross Barrels" 
                                    value={form?.grossBarrels ?? ''}
                                    onClick={e => (e.target as HTMLInputElement).select()}
                                    onChange={handleChange}
                                    />
                                </td>
                                <td>
                                    <input 
                                    id="bsw" 
                                    name="bsw"
                                    type="number" 
                                    step="0.01" 
                                    placeholder="Enter BS&W" 
                                    value= {form?.bsw ?? ''}
                                    onChange={handleChange}
                                    onClick={e => (e.target as HTMLInputElement).select()}
                                    />
                                </td>
                                <td>
                                    <input 
                                    id="topTemperature" 
                                    name="topTemperature"
                                    type="number" 
                                    step="0.01" 
                                    placeholder="Enter Top Temperature" 
                                    value= {form?.topTemperature ?? ''}
                                    onChange={handleChange}
                                    onClick={e => (e.target as HTMLInputElement).select()}
                                    />
                                </td>
                                <td>
                                    <input 
                                    id="bottomTemperature" 
                                    name="bottomTemperature"
                                    type="number" 
                                    step="0.01" 
                                    placeholder="Enter bottom Temperature" 
                                    value= {form?.bottomTemperature ?? ''}
                                    onChange={handleChange}
                                    onClick={e => (e.target as HTMLInputElement).select()}
                                    />
                                </td>
                                </tr>
                            </tbody>
                            </table>
                        {form && Object.values(form).some(temp => temp !== undefined && temp !== null && temp !== '') && (
                            <>
                                <button type="submit"> Convert </button>
                                <button type="button" onClick={() => clearForm()}> Clear </button>
                            </>
                        )}
                    </form>
                    <br />
                    <h3>Batch Excel Upload</h3>
                    <input type="file" accept=".xlsx,.xls" onChange={handleExcelUpload} />
                    {showHeaderMatch && (
                        <div style={{ marginTop: 16 }}>
                            <h4>Match Excel Columns to Required Inputs:</h4>
                            {requiredHeaders.map(h => (
                                <div key={h.key}>
                                    <label>{h.label}: </label>
                                    <select
                                        value={headerMap[h.key]}
                                        onChange={e => handleHeaderMapChange(h.key, e.target.value)}
                                    >
                                        <option value="">Select column</option>
                                        {excelRows.length > 0 &&
                                            Object.keys(excelRows[0]).map(col => (
                                                <option key={col} value={col}>{col}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            ))}
                            <button onClick={handleBatchProcessAndExport}>Process & Export</button>
                        </div>
                    )}
                    { correctedGravity?
                        <table className="conversion-table">
                            <thead>
                                <tr>
                                    <th> Variable</th>
                                    <th> Value </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Corrected Gravity</td>
                                    <td
                                        onClick={() => handleCopy(correctedGravity.toString(), 'val-API')}
                                        className="copy-cell"
                                    >
                                        {(correctedGravity).toFixed(3)}
                                        {copiedCell === 'val-API' && <span className="copy-tooltip">Copied!</span>}
                                    </td>
                                    
                                </tr>
                                <tr>
                                    <td>Net Standard Volume</td>
                                    <td
                                        onClick={() => handleCopy(netBarrels.toFixed(2), 'val-netBBL')}
                                        className="copy-cell"
                                    >
                                        {(netBarrels).toFixed(2)}
                                        {copiedCell === 'val-netBBL' && <span className="copy-tooltip">Copied!</span>}
                                    </td>
                                    
                                </tr>
                                
                                
                            </tbody>
                        </table>
                        :null
                    }
                </div>
            );
        }
        return (
            <div>
                <h2>API Gravity Converter</h2>
                <ConvertAPIGravity />

                <br/>
                <h2>SG to API Gravity Converter</h2>
                <ConvertSGGravity />
                <br/>
                <h2>Gross to Net Volume Converter</h2>
                <ConvertGross_Net />
                <br/>
                <h2>Calculate Weighted Average</h2>
                <WeightedAverage />
                <br/>
                <h2>Calculate API Temperature Correction</h2>
                <API_11_Correction />
                <br/>

            </div>
        );
    }
    export default Calculators;